import { FilterGroups, useFilters } from 'src/lib/services/api-query-params/use-filters';
import { requestFlow } from 'src/lib/services/api/request-api';
import { useTranslation } from 'react-i18next';
import { requestPriority, requestPriorityLabels } from 'src/api/services/RequestClient';

const useRequestFilters = () => {
  const { t } = useTranslation();
  const { toggleArrayFilter } = useFilters();

  const filterGroups: FilterGroups = {
    outcomes: {
      label: t('pages/shared:requests_list.filters.outcomes', { defaultValue: 'Outcomes' }),
      filters: [
        {
          label: t('pages/shared:requests_list.filters.flow.default', { defaultValue: 'Single' }),
          updater: toggleArrayFilter,
          filter: {
            id: 'flow',
            value: requestFlow.default,
            operator: 'in',
          },
        },
        {
          label: t('pages/shared:requests_list.filters.flow.multi_outcome', {
            defaultValue: 'Multiple',
          }),
          updater: toggleArrayFilter,
          filter: {
            id: 'flow',
            value: requestFlow.multiOutcome,
            operator: 'in',
          },
        },
        // {
        //   label: t('Repurpose'),
        //   updater: toggleArrayFilter,
        //   filter: {
        //     id: 'flow',
        //     value: requestFlow.repurpose,
        //     operator: 'in',
        //   },
        // },
      ],
    },
    // "Status details" filter group removed in #2383 — the column it
    // mirrored is gone from the table, and needs-attention / needs-re-edit
    // are now first-class signals on the status pill itself, so re-listing
    // them here as a substatus group reintroduces the same UI concept
    // Karina asked us to drop on the admin side.
    priority: {
      label: t('pages/shared:requests_list.filters.priority', { defaultValue: 'Priority' }),
      filters: [requestPriority.low, requestPriority.high].map((priority) => ({
        label: t(`pages/shared:requests_list.filters.priority.${priority}`, {
          defaultValue: requestPriorityLabels[priority],
        }),
        updater: toggleArrayFilter,
        filter: {
          id: 'priority',
          value: priority,
          operator: 'in',
        },
      })),
    },
  };

  return { filterGroups };
};

export { useRequestFilters };
